import React from 'react';
import moment from 'moment';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { makeUrl } from '../../utils/library';
import { required, number } from '../../utils/validation';
import { API_URL } from '../../utils/config';
import RenderCommonDropdownField from '../form-controls/RenderCommonDropdownField';
import RenderDatePicker from '../form-controls/RenderDatePicker';
import { Field, reduxForm, getFormValues, FormSection } from 'redux-form';
import { connect } from 'react-redux';
import {
  maxValueUptoTwoDecimal,
  r_maxLength,
  r_maxLengthWith2DigitsAfterDecimal
} from '../../utils/validation/restrictions';
import { tradeDetails } from '../../utils/templates/llptradedetails';
import { updateRecipientList } from '../../redux/actions/transaction/transaction-action';
import RenderTextField from '../form-controls/RenderTextField';
import { GOODS, SERVICE, CORPORATE, GOODS_SERVICE_FIELDS } from '../../utils/constants';
import LlpTradeDetails from '../../screens/user-flow/payment-method/LlpTradeDetails';
function ServiceHeader({ config }) {
  return config.map((item, i) => (
    <div key={`${config.message}-${i}`} className="service-header">
      <div className="header">
        {item.reason}
        <span>{item.resaonType}</span>
      </div>
      <div className="serivce-message">{item.message}</div>
    </div>
  ));
}
class ServiceFields extends React.Component {
  state = {
    disableAllFields: false,
    tradeDetails: null
  };
  onClickProceed = (props) => {
    this.setState(
      {
        disableAllFields: !this.state.disableAllFields
      },
      () => {
        /**
         * if disableAllFields false then this should update
         * root>transReducer>multiTrnas>recepinetList>[index]>additionalFields:{}
         */
        if (this.state.disableAllFields === true) {
          const keys = Object.keys(props);
          if (keys.length > 0) {
            //get current keys with respect to current fromId
            const currFormId = keys.filter((key) => key === this.props.formFieldsId);
            const currIndex = keys
              .filter((key) => key === this.props.formFieldsId)[0]
              .split('-')[1];
            //get current form value

            const currFormValue = props[currFormId];
            //dispatch action to update recepinet list
            this.props.updateRecipientList(parseInt(currIndex), currFormValue);
          }
        }
      }
    );
  };
  componentDidMount() {
    const { formFieldsId, goodsServiceFromVal, initialize } = this.props;
    const keyVal = Object.keys(goodsServiceFromVal).filter((key) => key !== formFieldsId);
    const newState = keyVal.reduce((prev, curr) => {
      return {
        ...prev,
        [curr]: goodsServiceFromVal[curr]
      };
    }, {});
    initialize({ ...newState, [formFieldsId]: { trade_currency: 'CNY' } });
  }
  render() {
    const {
      formFieldsId,
      headerConfig,
      viewFor = 'default',
      showConfirmButton,
      reason_for_transfer_text_trade_code,
      formData,
      currency_code,
      bene_account_type,
      handleSubmit
    } = this.props;
    const numberofRows = showConfirmButton === true ? 'four-rows' : 'three-rows';
    const className =
      viewFor === 'transaction'
        ? `section additional-fields-3-col ${numberofRows}`
        : `section additional-fields-2-col ${numberofRows}`;
    const buttonText = this.state.disableAllFields ? 'Edit Details' : 'Confirm';
    const renderFields =
      (reason_for_transfer_text_trade_code === GOODS ||
        reason_for_transfer_text_trade_code === SERVICE) &&
      currency_code === 'CNY' &&
      bene_account_type === CORPORATE;
    if (renderFields)
      return (
        <div className="grid-2row" key="additional-fields-cny">
          {viewFor === 'transaction' && <ServiceHeader config={headerConfig} />}
          <form
            id={`${GOODS_SERVICE_FIELDS}-${formFieldsId}`}
            onSubmit={handleSubmit(this.onClickProceed)}
          >
            <FormSection name={formFieldsId} className={className}>
              <Field
                name={`amount`}
                type="text"
                className={'input form-flow'}
                component={RenderTextField}
                normalize={maxValueUptoTwoDecimal(7)}
                disabled={this.state.disableAllFields}
                validate={[required]}
                placeholder="Amount"
                tooltip={
                  <LlpTradeDetails config={{ data: 'Please enter the transaction amount.' }} />
                }
              />
              <Field
                name={`trade_order_id`}
                type="text"
                className={'input form-flow'}
                component={RenderTextField}
                normalize={r_maxLength(32)}
                validate={[required, number]}
                disabled={this.state.disableAllFields}
                placeholder="Trade Order ID"
                tooltip={<LlpTradeDetails config={{ data: 'Please enter the invoice number.' }} />}
              />
              <Field
                name={`trade_time`}
                type="text"
                className="input form-flow extra-padding-datepicker"
                component={RenderDatePicker}
                normalize={r_maxLength(50)}
                validate={[required]}
                parse={(val) => val && moment(val).format('DD/MM/YYYY')}
                placeholder="Trade Time"
                disabled={this.state.disableAllFields}
              />
              <Field
                bindToThisObject={
                  formData && formData[formFieldsId] && formData[formFieldsId].trade_currency
                }
                name={`trade_currency`}
                disabled={this.state.disableAllFields}
                type="text"
                className="dropdown choose-bank"
                component={RenderCommonDropdownField}
                placeholder="Trade Currency"
                url={`${API_URL}/currencies/dropdown`}
              />
              <Field
                name={`trade_amount`}
                disabled={this.state.disableAllFields}
                type="text"
                className={'input form-flow'}
                component={RenderTextField}
                normalize={r_maxLengthWith2DigitsAfterDecimal(15)}
                validate={[required]}
                placeholder="Trade Amount"
                tooltip={
                  <LlpTradeDetails
                    config={{
                      data: 'Please enter the amount mentioned in the invoice.'
                    }}
                  />
                }
              />
              {reason_for_transfer_text_trade_code === SERVICE ? (
                <Field
                  name={`trade_name`}
                  bindToThisObject={
                    formData && formData[formFieldsId] && formData[formFieldsId].trade_name
                  }
                  disabled={this.state.disableAllFields}
                  type="text"
                  className="dropdown choose-bank"
                  component={RenderCommonDropdownField}
                  placeholder="Trade Name"
                  validate={[required]}
                  fluid={true}
                  isSearchable={true}
                  url={makeUrl(`${API_URL}/instarem-objects/dropdown`, {
                    type: 'SERVICE_NAME',
                    value: 'name'
                  })}
                  onDropdownChange={(obj) => {
                    let data = tradeDetails.find((x) => x.code === obj.code);
                    if (!data) {
                      data = tradeDetails.find((x) => x.code === 'OTHERS');
                    }
                    this.setState({ tradeDetails: data });
                  }}
                />
              ) : (
                <Field
                  name={`trade_name`}
                  type="text"
                  disabled={this.state.disableAllFields}
                  className={'input form-flow'}
                  component={RenderTextField}
                  normalize={r_maxLength(50)}
                  validate={[required]}
                  placeholder="Trade Name"
                />
              )}
              {reason_for_transfer_text_trade_code === SERVICE && (
                <div className="serviceRow">
                  <Field
                    name={`service_time`}
                    disabled={this.state.disableAllFields}
                    type="text"
                    className={'input form-flow'}
                    component={RenderTextField}
                    normalize={r_maxLength(50)}
                    validate={[required]}
                    placeholder="Service Time"
                    tooltip={
                      this.state.tradeDetails &&
                      this.state.tradeDetails.serviceTime && (
                        <LlpTradeDetails config={this.state.tradeDetails.serviceTime} />
                      )
                    }
                  />
                </div>
              )}
              {reason_for_transfer_text_trade_code === GOODS && (
                <Field
                  name={`goods_carrier`}
                  disabled={this.state.disableAllFields}
                  type="text"
                  className={'input form-flow'}
                  component={RenderTextField}
                  normalize={r_maxLength(50)}
                  validate={[required]}
                  placeholder="Goods Carrier"
                />
              )}
              <Field
                disabled={this.state.disableAllFields}
                name={`trade_count`}
                type="text"
                className={'input form-flow'}
                component={RenderTextField}
                normalize={r_maxLength(9)}
                validate={[required, number]}
                placeholder="Trade Count"
                tooltip={
                  <LlpTradeDetails
                    config={{
                      data: 'Please enter the number of services purchased.'
                    }}
                  />
                }
              />
              {reason_for_transfer_text_trade_code === SERVICE && (
                <div className="serviceRow">
                  <Field
                    name={`service_detail`}
                    type="text"
                    className={'input form-flow'}
                    component={RenderTextField}
                    normalize={r_maxLength(50)}
                    placeholder="Service Details"
                    disabled={this.state.disableAllFields}
                    tooltip={
                      this.state.tradeDetails &&
                      this.state.tradeDetails.serviceDetails && (
                        <LlpTradeDetails config={this.state.tradeDetails.serviceDetails} />
                      )
                    }
                  />
                </div>
              )}
              {showConfirmButton === true && (
                <div className={`proceed-btn-wrapper `}>
                  <button className={`proceed-btn `} type="submit">
                    {buttonText}
                  </button>
                </div>
              )}
            </FormSection>
          </form>
        </div>
      );
    else {
      return null;
    }
  }
}

ServiceFields.propTypes = {
  formFieldsId: PropTypes.any,
  updateRecipientList: PropTypes.any,
  headerConfig: PropTypes.any,
  viewFor: PropTypes.any,
  showConfirmButton: PropTypes.any,
  reason_for_transfer_text_trade_code: PropTypes.any,
  formData: PropTypes.any,
  currency_code: PropTypes.any,
  bene_account_type: PropTypes.any,
  handleSubmit: PropTypes.any,
  initialize: PropTypes.func,
  goodsServiceFromVal: PropTypes.func
};

ServiceFields.defaultProps = {
  formFieldsId: `somesampleId`,
  headerConfig: [
    {
      reason: 'default resons',
      resaonType: 'e.g Service',
      message: 'As per the partnered bank regulation, you need to provide service details.'
    }
  ],
  trade_currency: null,
  trade_name: null,
  showConfirmButton: true
};
const mapStateToProps = (store, ownProps) => {
  const formValues = getFormValues(`${GOODS_SERVICE_FIELDS}-${ownProps.formFieldsId}`)(store);
  return {
    formData: formValues,
    form: `${GOODS_SERVICE_FIELDS}-${ownProps.formFieldsId}`
  };
};
const ServiceGoodsFeilds = compose(
  connect(mapStateToProps, { updateRecipientList }),
  reduxForm({ destroyOnUnmount: false, keepDirtyOnReinitialize: true })
)(ServiceFields);

export { ServiceGoodsFeilds };
